<div class="dropdown">
	<div (click)="toggleDropDown()">
		<ng-content select="ea-dropdown-button"></ng-content>
	</div>
	<div
		[ngClass]="{
			active: isActive,
			'show-arrow': showArrow,
			'menu-dropdown': dropdownType === DROPDOWN_TYPES.Menu,
			'input-dropdown': dropdownType === DROPDOWN_TYPES.Input,
			top: orientation === DROPDOWN_ORIENTATION.Top,
			left: orientation === DROPDOWN_ORIENTATION.Left,
			right: orientation === DROPDOWN_ORIENTATION.Right
		}"
		class="dropdown-content"
	>
		<ng-container *ngTemplateOutlet="dropDownContentTemplate"></ng-container>
	</div>
</div>
@if (isActive) {
	<ea-ui-overlay (close)="overlayClick()"></ea-ui-overlay>
}
